import React from 'react';

import { LogInIcon, LogOutIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '../../../lib/utils';

export interface ViewerAuthButtonProps extends
  WithDataTestid,
  Omit<IconButtonProps, 'onClick'> {
  onLogin?: VoidFunction;
  onLogout: VoidFunction;
  isAuthenticated: boolean;
}

const displayName = 'ViewerAuthButton';
const testid = buildTestid(displayName);

function ViewerAuthButton({
  onLogin,
  onLogout,
  isAuthenticated,
  'data-testid': dataTestId = undefined,
  ...props
}: ViewerAuthButtonProps): React.JSX.Element {
  const icon = isAuthenticated ? <LogInIcon /> : <LogOutIcon />;

  return (
    <IconButton
      icon={icon}
      kind="secondary"
      onClick={() => (isAuthenticated ? onLogout() : onLogin())}
      shape="square"
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

ViewerAuthButton.displayName = displayName;

export { ViewerAuthButton };
